export default __webpack_public_path__ + "static/media/list-thumbnail.b68927a0.png";